import { sortBy } from "lodash-es";
import { FixtureStatuses } from "~enums/fixtureStatuses";
import type { FixtureTransformed } from "../types";

type ValueIteratee<T> = ((value: T) => any) | keyof T | Partial<T>;

// TODO: fix lint warning
const getIterateeValue = <T>(item: T, iteratee: ValueIteratee<T>): any => {
  if (typeof iteratee === "function") {
    return iteratee(item);
  } else if (typeof iteratee === "string") {
    return item[iteratee];
  } else {
    return null;
  }
};

export const mapMultiSelectOptions = <T>(
  items: T[],
  valueFunc: ValueIteratee<T>,
  labelFunc: ValueIteratee<T>,
  disabledFunc?: ValueIteratee<T>,
) => {
  return sortBy(
    items.map((item: any) => ({
      value: getIterateeValue(item, valueFunc),
      label: getIterateeValue(item, labelFunc),
      disabled: disabledFunc ? getIterateeValue(item, disabledFunc) : false,
    })),
    [(x) => x.label?.toLowerCase(), (x) => x.value?.toLowerCase()],
  );
};

export const isFixtureEditable = (fixture: FixtureTransformed, checkStatus: boolean) =>
  (!checkStatus ||
    ![FixtureStatuses.Confirmed, FixtureStatuses.InProgress, FixtureStatuses.Finished].includes(fixture.status as FixtureStatuses)) &&
  !fixture.locked;
